export const apiDateFormat = "YYYY-MM-DDTHH:mm:ss" as const;
